import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { USER_MGMT_CNST } from '../../../../constants/proj.cnst';
import { UM_TABLE_CNST } from '../../../../constants/table.cnst';
import { AppStateService } from '../../../../services/app-state.service';
import { ConfirmationService } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ChipModule } from 'primeng/chip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TooltipModule } from 'primeng/tooltip';
import { PrimengTableComponent } from '../../../../modules/shared/components/primeng-table/primeng-table.component';
import { TruncatePipe } from '../../../../pipes/truncate.pipe';
import { SkeletonModule } from '../../../../modules/shared/components/skeleton/skeleton.module';
import { IconEdit, IconEye, IconTrash } from 'angular-tabler-icons/icons';
import { TablerIconComponent,provideTablerIcons } from 'angular-tabler-icons';


@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  standalone : true,
  imports : [
    CommonModule,
    PrimengTableComponent,
    TruncatePipe,
    SkeletonModule,
    TablerIconComponent,
    ButtonModule,
    ChipModule,
    ConfirmDialogModule,
    TooltipModule,
  ],providers:[
    provideTablerIcons({
      IconEdit, IconEye, IconTrash}) ]
})

export class UsersListComponent {
  @Input() tableConfig: any = {};
  @Input() tableData: any = [];
  @Input() isCustomer: any = false;

  loading: boolean = false;


  dataTypes = UM_TABLE_CNST.CLICKABLE_DATA_TYPE;
  opts = USER_MGMT_CNST.OPTIONS;
  showUserId : boolean = false;
  showDeletePopup: boolean = false;
  rowData: any;
  constructor(
    private appStateSrv: AppStateService,
    private router: Router,
    private confirmationService: ConfirmationService,
  ) { }


  handleOptionClick(rowData: any, operation: string) {  
    this.rowData = rowData; 
    let data = rowData;
    if(operation == USER_MGMT_CNST.OPTIONS.DELETE) {
      this.confirmationService.confirm({
        // target: event.target as EventTarget,
        message: 'Do you want to delete this user?',
        header: 'Confirmation',
        // rejectButtonStyleClass: "p-button-text",
        rejectButtonProps: {
          label: 'Cancel',
          severity: 'secondary',
          outlined: true,
        },
        acceptButtonProps: {
          label: 'Delete',
          severity: 'danger',
          // size:'large'
        },
        accept: () => {
          this.protectedToDeleteOrNot(true);
        },
        reject: () => {
        }
      });
    }else {
      this.router.navigate(['usermgmt','users','config'], {
        queryParams: {
          operation: operation.toLowerCase(),
          userId: data.userId,
          config: 'info'
        }
      })
    }
  }

  protectedToDeleteOrNot(option: boolean) {
    if(!option) {
      this.showDeletePopup = false;
    }
    else {
      const postData = {
        userId: this.rowData.userId
      }
      this.setOperationType({
        operation: USER_MGMT_CNST.OPERATION_TYPES.USER.DELETE_USER,
        postData
      });
    }
  }

  setOperationType(value : any) {
    this.appStateSrv.operationRef.next(value);
  }


  async setTableData(size : any = null) {
      this.loading = true;
  
      // let options = {
      //   'queryParams': {
      //     size:  isNullOrUndefined(size) ? USER_MGMT_CNST.INFINITE_SCROLL_OPTIONS.INFINITE_SCROLL_LIMIT : size,
      //     offset: this.currentOffset
      //   }
      // }
  
      // let profilesListApiResponse = await this.commonSrv.getProfilesList(options);
      // let responseKeys = Object.keys(profilesListApiResponse);
  
      this.loading = false;
  
      // if (!this.isCustomerListFetched) {
      //   this.setCustomerListData();
      // }
  
      // if (responseKeys.length > 0) {
      //   let tableData = this.formatTableData(profilesListApiResponse);
  
      //   // * If page was scrolled and edit/add/delete was not performed
      //   if (this.wasPageScrolled && isNullOrUndefined(this.currentOperation)) {
      //     this.tableData = [...this.tableData, ...tableData];
      //   } else if (this.currentOffset === 0) {
      //       this.tableData = tableData;
      //     }
  
        // this.totalRecordCount = this.currentOffset === 0
        //   ? tableData.length
        //   : this.totalRecordCount + tableData.length;
  
        // this.currentOperation = null;
  
        // if (!isNullOrUndefined(size)) {
        //   this.currentOffset = this.totalRecordCount + 1;
        // }
      }
    }


